import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../../common/theme/tokens.css';

const sections = [
  {
    title: 'Il progetto Mangitalia',
    body: `Mangitalia nasce per collegare chi produce cibo artigianale italiano con chi vuole gustarlo a casa, 
    rispettando filiere corte, stagionalità e autenticità. Non siamo un marketplace generico: ogni categoria 
    del catalogo è selezionata, valutata e garantita dalla piattaforma, con prezzo trasparente e fornitore 
    assegnato in base a prossimità, capacità produttiva e qualità certificata.`,
  },
  {
    title: 'Come funziona per te',
    body: `Sfogli i prodotti per provenienza e tipologia (fresco, secco, fragile). Indica dove vuoi ricevere 
    la consegna: mostriamo solo ciò che può arrivare fresco entro il raggio di trasporto dei nostri produttori. 
    Ogni ordine passa da un preventivo chiaro (prodotto + trasporto) prima del pagamento sicuro con Stripe.`,
  },
  {
    title: 'Tutele dei consumatori',
    items: [
      'Prezzo fisso per categoria, comunicato prima dell\'acquisto — nessuna sorpresa in cassa.',
      'Fornitori ufficiali con questionario qualità e campioni verificati da Mangitalia.',
      'Tracciabilità dell\'ordine e assistenza tramite area riservata e segnalazioni pubbliche.',
      'Diritto di recesso e rimborso gestiti secondo normativa e-commerce italiana ed europea.',
      'Dati personali trattati nel rispetto del GDPR; pagamenti gestiti da provider certificati PCI.',
      'In caso di prodotto non conforme o consegna problematica, canale di segnalazione dedicato con follow-up.',
    ],
  },
  {
    title: 'Il nostro impegno',
    body: `Stiamo ampliando costantemente la rete di produttori e corrieri per portare più sapori in più zone. 
    Se oggi un prodotto non è consegnabile nella tua area, è un limite temporaneo: il nostro obiettivo è 
    allargare i confini della filiera corta, regione per regione, senza compromettere la freschezza.`,
  },
];

export default function ChiSiamo() {
  return (
    <div className="min-h-screen bg-[#FFFEFA]">
      <div className="mang-gradient py-14 px-4 text-white text-center">
        <motion.h1
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-3xl font-bold mb-2"
        >
          Chi siamo
        </motion.h1>
        <p className="text-sm opacity-90 max-w-xl mx-auto">
          Mangitalia — il gusto dell&apos;Italia artigianale, con tutela e trasparenza
        </p>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-12 space-y-10">
        {sections.map((s, i) => (
          <motion.section
            key={s.title}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.08 }}
            className="mang-card p-8"
          >
            <h2 className="text-xl font-bold text-[#c78244] mb-4">{s.title}</h2>
            {s.body && <p className="text-gray-600 leading-relaxed whitespace-pre-line">{s.body}</p>}
            {s.items && (
              <ul className="space-y-3 mt-2">
                {s.items.map((item) => (
                  <li key={item} className="flex gap-3 text-gray-600 text-sm leading-relaxed">
                    <span className="text-[#F6CF48] font-bold shrink-0">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </motion.section>
        ))}

        <div className="flex flex-wrap gap-4 justify-center pt-4">
          <Link
            to="/catalogo"
            className="bg-[#c78244] text-white px-6 py-3 rounded-xl font-semibold hover:opacity-90"
          >
            Esplora il catalogo
          </Link>
          <Link
            to="/diventa-partner"
            className="border border-[#c78244] text-[#c78244] px-6 py-3 rounded-xl font-semibold hover:bg-[#c78244]/5"
          >
            Sei produttore? Candidati
          </Link>
          <Link
            to="/segnalazione"
            className="border border-gray-300 text-gray-600 px-6 py-3 rounded-xl font-semibold hover:bg-gray-50"
          >
            Segnalazioni e assistenza
          </Link>
        </div>
      </div>
    </div>
  );
}
